//========================================================================================================\\
// See if OOH needs to be applied.  There are some rules here:
// --Mon-Sat 18:00-08:00h = OOH ☑
// --Sat Before 09:00 and after 12:00h = OOH ☑
// --Sun all day = OOH ☑
// --OOH Never applied to Airport, Meet-And-Greet, Walk-in or International locations ☑
// --Check against customers tariff to see whether OOH is to be applied to Delivery, Collection, Both or None ☑
// const splitHours = hrs =>

export const setDate = (d, time = '') => {
	let date = new Date(d)
	const [h, m, s = '00'] = time.split(':')
	date.setHours(h)
	date.setMinutes(m)
	date.setSeconds(s)
	return date
}
const isOutOfHours = (opening, closing) => day => {
	const parsedOpening = Date.parse(opening.toString())
	const parsedClosing = Date.parse(closing.toString())
	return day < parsedOpening || day > parsedClosing
}

export default function useCheckIfOutOfHours({ start, end, openingHours }) {
	/* manage out of hours state  */
	let outOfHours = false
	let value = null
	/* make sure we're defined  */

	if (start && end && openingHours) {
		// get the network request data
		const { collectionHours = [], deliveryHours = [] } = openingHours

		// rental period config
		const startDay = new Date(start).getDay()
		const endDay = new Date(end).getDay()

		// set the day with opening time
		let deliveryOpening = setDate(start, deliveryHours[startDay]?.opening)
		let deliveryClosing = setDate(start, deliveryHours[startDay]?.closing)

		// set the day with closing time

		let collectionOpening
		let collectionClosing
		let isStartOoh
		let isEndOoh

		if (collectionHours.length > 0) {
			collectionOpening = setDate(end, collectionHours[endDay].opening)
			collectionClosing = setDate(end, collectionHours[endDay].closing)
		}

		// set ooh

		if (collectionHours.length > 0 && deliveryHours.length > 0) {
			isStartOoh = isOutOfHours(deliveryOpening, deliveryClosing)(start)
			isEndOoh = isOutOfHours(collectionOpening, collectionClosing)(end)
		}

		const bothAreOoh = isStartOoh && isEndOoh

		/* both */
		if (bothAreOoh) {
			outOfHours = true
			value = 'both'
			/* delivery */
		} else if (isStartOoh) {
			outOfHours = true
			value = 'delivery'
			/* collection */
		} else if (isEndOoh) {
			outOfHours = true
			value = 'collection'
			/* default */
		} else {
			outOfHours = false
			value = null
		}
	}
	return { outOfHours, value }
}
